var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-button-active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M16 0V16H0L0 0L16 0ZM5.7953 3.61026H2.67908V3.79086L3.68269 4.99987C3.78122 5.08868 3.83154 5.21909 3.81818 5.35104V10.1018C3.84742 10.2732 3.79339 10.4483 3.67266 10.5734L2.54359 11.9429V12.1235H5.74512V11.9429L4.61606 10.5734C4.49443 10.4485 4.43706 10.2746 4.46049 10.1018V5.99317L7.27062 12.1235H7.59679L10.0105 5.99317L10.0104 10.9077C10.01 11.014 10.0039 11.0415 9.92518 11.1202L9.05705 11.963V12.1436H13.2722V11.963L12.4342 11.1403C12.3602 11.0839 12.3235 10.9912 12.3389 10.8995V4.85439C12.3235 4.76266 12.3602 4.66998 12.4342 4.61359L13.2923 3.79086V3.61026H10.3216L8.20398 8.8928L5.7953 3.61026Z",
    fill: "#A0A3A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium_icon.c4848f1242cf56082b82ae6086e72432.svg";
export { ForwardRef as ReactComponent };